import { Flex, Tabs } from 'antd';
import { useTranslation } from 'react-i18next';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { CompanySelectBh } from '@/components/company-select-bh/company-select-bh';
import tabStyles from '@/components/tab/tab.module.scss';
import layout from '@/styles/layout.module.scss';
import { OUTBOUND_TABS, OutboundTab } from './outbound-calls.routes';
import { OutboundContext, callsOut, useOutboundCompanySelection } from './outbound-calls.context';

const SECTION_PATH = '/outbound-calls';

const activeTab = (pathname: string): OutboundTab =>
  OUTBOUND_TABS.find((tab) => pathname.startsWith(`${SECTION_PATH}/${tab}`)) ?? 'campaigns';

/** Section shell: the company every tab works on, and the tabs as routes. */
export function OutboundCalls() {
  const { t } = useTranslation('outbound');
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { selectedCompany, selectCompany } = useOutboundCompanySelection();

  return (
    <Flex vertical className={layout.page}>
      <CompanySelectBh value={selectedCompany} onChange={selectCompany} filter={callsOut} />

      <Tabs
        className={tabStyles.tabs}
        activeKey={activeTab(pathname)}
        onChange={(key) => navigate(`${SECTION_PATH}/${key}`)}
        items={OUTBOUND_TABS.map((key) => ({ key, label: t(`tabs.${key}`) }))}
      />

      {selectedCompany ? (
        // Keyed so a company switch drops every tab's local filters and open panels.
        <Outlet
          key={selectedCompany.id}
          context={{ company: selectedCompany } satisfies OutboundContext}
        />
      ) : (
        <p className={layout.empty}>{t('pickCompany')}</p>
      )}
    </Flex>
  );
}
